var proaccordions = document.querySelectorAll('.proaccordion');
for (var i = 0; i < proaccordions.length; i++) {
  proaccordions[i].addEventListener('click', function() {
    var clickedAccordion = this;
    var tabcontent = clickedAccordion.nextElementSibling;
    clickedAccordion.classList.toggle('active');
    if (clickedAccordion.classList.contains('active')) {
      tabcontent.classList.add('active');
      tabcontent.style.maxHeight = tabcontent.scrollHeight + 'px';
    } else {
      tabcontent.classList.remove('active');
      tabcontent.style.maxHeight = null;
    }
  });
}